import React, { useState, useEffect } from 'react';

const Switch = ({ value, onChange = () => {}, disabled = false }) => {
  const [isChecked, setIsChecked] = useState(value);

  const handleToggle = () => {
    if (disabled) {
      return ;
    }
    const newState = !isChecked;
    setIsChecked(newState);
    onChange(newState);
  };

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  return (
    <div className={`switch ${isChecked ? 'switch-on' : 'switch-off'}`} onClick={handleToggle}>
      <div className={`switch-toggle ${isChecked ? 'toggle-on' : 'toggle-off'}`}></div>
    </div>
  );
};

export default Switch;
